module.exports = __webpack_public_path__ + "img/jepl_files.6fc22814.png";